var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brick-container",class:_vm.isHome},_vm._l((_vm.projects),function(item,index){return _c('Brick',{key:index,attrs:{"item":item,"to":{ path: '/projects/' + item.id }}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }